import { render } from "./SdaLinkedSelect.vue?vue&type=template&id=e8d20a42"
import script from "./SdaLinkedSelect.vue?vue&type=script&lang=js"
export * from "./SdaLinkedSelect.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__